
import React from 'react';
import Field  from './Field';
import Input from './Input';

import indexOf from 'lodash/indexOf';
import pick from 'lodash/pick';
import omit from 'lodash/omit';

// {name, allowNull, children, component, format, isEqual, parse, render, subscription, validate, validateFields, value, ...rest}

const fieldPropKeys = [
  'name',
  'allowNull',
  'children',
  'component',
  'format',
  'formatOnBlur',
  'isEqual',
  'parse',
  'render',
  'subscription',
  'validate',
  'validateFields',
  'value'
];



class InputField extends React.Component {
  
  constructor (props) {
    super(props);
    
    this.focusRef = null;
    this.setFocusRef = element => {
      this.focusRef = element;
    };
  }
  
  componentDidMount (){
    const { focusOnMount } = this.props;
    if (!!focusOnMount && this.focusRef && this.focusRef.focus)
      setTimeout(() => {
        this.focusRef.setAttribute('autofocus', 'autofocus');
        this.focusRef.focus();
        this.focusRef.click();
      }, parseInt(focusOnMount, 10));
  }
  
  
  render () {
    // const {name, allowNull, children, component, format, isEqual, parse, render, subscription, validate, validateFields, value, meta, ...rest} = props
    const { value, children, focusOnMount } = this.props;
    const mergeMeta = this.props.meta;
    const fieldProps = pick(this.props, fieldPropKeys)
    const rest = omit(this.props, [...fieldPropKeys, 'value', 'children', 'focusOnMount'])
    
    return (
      <Field {...fieldProps}>
        {({ input, meta }) => {
          const checked = input.value instanceof Array && indexOf(input.value, value) > -1
          return (<Input inputRef={!!focusOnMount ? this.setFocusRef : null} {...Object.assign(input,rest,{value: input.value,checked})} meta={Object.assign(meta,mergeMeta)}>
            {children}
          </Input>)
        }}
      </Field>
    )
  }
}


export default InputField;







// WEBPACK FOOTER //
// ./src/components/form/InputField.js